import { Navigate, Outlet } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { useGetLeases } from '~modules/leases/api/api-hooks/use-get-leases';
import { useOnboardingDraft } from '~modules/onboarding/onboarding-draft';
import {
  ONBOARDING_STEP_QUERY_PARAM,
  ONBOARDING_WELCOME_STEP,
  shouldRedirectToLessorOnboarding,
} from '~modules/onboarding/utils/onboarding-eligibility';
import { useGetProperties } from '~modules/properties/api/api-hooks/use-get-properties';
import { useGetUser } from '~modules/user/api/hooks/use-get-user';
import { useGetUserMeta } from '~modules/user/api/hooks/use-get-user-meta';

import { ROUTES } from '~app/router/routes';

export const LessorOnboardingRoute = () => {
  const { data: user, isLoading: isUserLoading } = useGetUser();
  const { data: meta, isLoading: isMetaLoading } = useGetUserMeta();
  const draft = useOnboardingDraft(user?.id);
  const shouldCheckEmptyAccount = Boolean(
    user?.id && meta && !draft && !meta.lessor.onboarding_completed_at,
  );
  const { data: properties, isSuccess: arePropertiesReady } = useGetProperties({
    options: {
      enabled: shouldCheckEmptyAccount,
    },
  });
  const { data: leases, isSuccess: areLeasesReady } = useGetLeases({
    options: {
      enabled: shouldCheckEmptyAccount,
    },
  });

  const isLoading = isUserLoading || isMetaLoading;

  if (isLoading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <CircularProgress size={28} />
      </Box>
    );
  }

  const canResolveEmptyAccount =
    shouldCheckEmptyAccount && arePropertiesReady && areLeasesReady;

  if (
    canResolveEmptyAccount &&
    shouldRedirectToLessorOnboarding({
      draft,
      properties,
      leases,
      meta,
    })
  ) {
    return (
      <Navigate
        to={`${ROUTES.ONBOARDING}?${ONBOARDING_STEP_QUERY_PARAM}=${ONBOARDING_WELCOME_STEP}`}
        replace
      />
    );
  }

  return <Outlet />;
};
